import { render, staticRenderFns } from "./ListHomeworkStudent.vue?vue&type=template&id=b54b0ebe&scoped=true"
import script from "./ListHomeworkStudent.vue?vue&type=script&lang=js"
export * from "./ListHomeworkStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54b0ebe",
  null
  
)

export default component.exports